import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-856 -640)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000610352H0V19.9999H20V0.000610352Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H5V19.9998H20V0Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ t("path", {
      d: "M14.5498 11.6125C13.3164 12.5038 11.5939 12.2263 10.7027 10.9929C9.81137 9.75938 10.0888 8.03694 11.3223 7.14574C11.7069 6.86789 12.139 6.7036 12.5787 6.64649C11.7329 6.51997 10.8389 6.71059 10.0909 7.25097C8.57282 8.34791 8.23133 10.4678 9.32824 11.986C10.4252 13.504 12.5451 13.8455 14.0632 12.7485C14.8112 12.2081 15.2729 11.4193 15.4183 10.5765C15.226 10.9759 14.9344 11.3346 14.5498 11.6125Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M14.4964 6.60889L15.1912 7.35767L16.118 6.92838L15.6205 7.82051L16.3153 8.56937L15.313 8.37191L14.8155 9.26409L14.6936 8.24988L13.6914 8.05242L14.6183 7.62309L14.4964 6.60889Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  r as default
};
